
import LoginForm from '~/components/Login/LoginForm'
import LoginActions from '~/components/Login/LoginActions'

export default {
  name: 'LoginPage',
  components: {
    LoginForm,
    LoginActions,
  },
  layout: 'login',
}
